<template>
  <div v-if="">
    <el-row>
      <el-col :span="12">
        <router-link :to="Paths.DOCUMENT_MANAGEMENT" class="quick-action">
          <FAIcon icon="fas fa-file-alt" />
          Kiểm tra tài liệu
        </router-link>
      </el-col>
      <el-col :span="12">
        <router-link v-if="tagPermissions.includes(Permission.READ)" :to="Paths.TAG_MANAGEMENT" class="quick-action">
          <FAIcon icon="fas fa-folder-open" />
          Danh sách thư mục
        </router-link>
        <router-link v-else :to="Paths.USER_PROFILE_INFORMATION" class="quick-action">
          <FAIcon icon="fas fa-user" />
          Thông tin tài khoản
        </router-link>
      </el-col>
      <el-col :span="12">
        <router-link v-if="groupPermissions.includes(Permission.READ)" :to="Paths.GROUP_MANAGEMENT" class="quick-action">
          <FAIcon icon="fas fa-paste" />
          Kiểm tra nhóm
        </router-link>
        <router-link v-else :to="Paths.DOCUMENT_MANAGEMENT" class="quick-action">
          <FAIcon icon="fas fa-paste" />
          Danh sách tài liệu
        </router-link>
      </el-col>
      <el-col :span="12">
        <router-link v-if="isAdmin" :to="Paths.ADMIN_GENERAL_STATISTIC" class="quick-action">
          <FAIcon icon="fas fa-users-cog" />
          Quản trị hệ thống
        </router-link>
        <div v-else @click="logout" class="quick-action">
          <FAIcon icon="fas fa-user" />
          Đăng xuất tài khoản
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HomeCard from '@/components/HomeComponents/HomeCard.vue'
import { mapGetters, mapState } from 'vuex'
import { AUTHENTICATE_STORE, AuthenticateGetter } from '@/store/modules/AuthenticateStore.js'
import CardHeader from '@/components/HomeComponents/CardHeader.vue'
import FAIcon from '@/components/common/FAIcon.vue'
import { Paths } from '@/routes/paths.js'
import {Permission} from '@/constants/DoITConstant.js'
import {logout} from '@/services/authentication_service.js'
export default {
  name: 'HomeQuickActions',
  components: { FAIcon, HomeCard, CardHeader },
  data() {
    return {
      Paths,
      Permission,
      logout
    }
  },
  computed: {
    ...mapState({
      user: (state) => state[AUTHENTICATE_STORE].user,
    }),
    ...mapGetters({
      isAdmin: AuthenticateGetter.IS_ADMIN,
      groupPermissions: AuthenticateGetter.GROUP_PERMISSIONS,
      documentPermissions: AuthenticateGetter.DOCUMENT_PERMISSIONS,
      tagPermissions: AuthenticateGetter.TAG_PERMISSIONS,
    }),
  },
}
</script>

<style lang="scss" scoped>
.quick-action {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  border: 1px lightgray solid;
  border-radius: 5px;
  margin: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  color: black;
  background-color: white;
  span {
    font-size: 1.2rem;
    margin-right: 0.5rem;
  }
}
.quick-action:hover {
  background-color: whitesmoke;
}
</style>
